<template>
  <v-row>
    <v-col cols="12" NewEditDeleteDialog>
      <v-dialog v-model="dialog" persistent max-width="1000">
        <v-card :loading="loading" v-if="!deleting">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{ newResource.id ? i18n.edit : i18n.add }}</span></div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="py-0" v-for="(field, k) in resourceKeys" :key="'key-' + k">
                <v-text-field
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  outlined
                  :readonly="newResource.id && (field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly)"
                  :disabled="newResource.id && (field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly)"
                  v-if="field.type == 'text'"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                ></v-text-field>
                <v-textarea
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  outlined
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  v-if="field.type == 'textarea'"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                ></v-textarea>
                <v-text-field
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  outlined
                  v-if="field.type == 'number'"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  @keypress="isNumber($event)"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                ></v-text-field>
                <v-autocomplete
                  :items="field.data"
                  v-model="newResource[field.name]"
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  autocomplete="disabled"
                  :rules="[ field.required ? rules.required : false]"
                  v-if="field.type == 'select'"
                  :readonly="newResource.id && field.readonly"
                  :disabled="newResource.id && field.readonly"
                  outlined
                  dense
                  :item-value="`${field.name}_id`"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                </v-autocomplete>
                <v-switch 
                  v-if="field.type == 'switch'"
                  :name="getNameID()"
                  :id="getNameID()"
                  :class="`${arabic?'arFont':'enFont'}`" 
                  :label="i18n[field.label]" 
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  v-model="newResource[field.name]"
                ></v-switch>
                <v-menu
                  v-model="datepicker[field.name]"
                  :close-on-content-click="false"
                  v-if="field.type == 'date'"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="i18n[field.label]"
                      :name="getNameID()"
                      :id="getNameID()"
                      outlined
                      :disabled="field.readonly"
                      v-if="field.type == 'date'"
                      autocomplete="disabled"
                      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                      dense
                      :class="`${arabic?'arFont':'enFont'}`"
                      v-model="newResource[field.name]"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newResource[field.name]"
                    @input="datepicker[field.name] = false"
                  ></v-date-picker>
                </v-menu>
                <vue-editor ref="editorV" v-if="field.type == 'editor'" v-model="newResource[field.name]"></vue-editor>
                <v-btn v-if="field.type == 'editor'" color="success" @click="setRTL()">RTL</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click.native="closeDialog()" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
            <v-btn 
              color="success" 
              v-if="!newResource.id"
              :disabled="!validate(newResource)"
              text @click.native="postResource(newResource)" 
              :class="`${arabic?'arFont':'enFont'}`"
            >{{i18n.submitBtn}}</v-btn>
            <v-btn 
                color="success" 
                v-if="newResource.id"
                :disabled="!validate(newResource)"
                text @click.native="updateResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.updateBtn}}</v-btn>
          </v-card-actions>
        </v-card>
        <v-card :loading="loading" v-if="deleting">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{i18n.delete}}</span></div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="pa-5 error white--text">
                {{i18n.areYouSureOfDelete.replace('|item|', newResource.name )}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click.native="closeDialog()" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
            <v-btn 
                color="error" 
                v-if="newResource.id"
                text @click.native="deleteResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.deleteBtn}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  components: {
    VueEditor
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings'],
  data(){
    return {
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      datepicker:{},
      timepicker:{},
      menu:{},
    }
  },
  methods: {
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>